module.exports = __webpack_public_path__ + "static/media/seeHistory.0fc679b5.svg";